var React = require('react');

function UnlimitedDepartments (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M0 0h24v24H0z","fill":"none","key":0}),React.createElement("path",{"d":"M3 5H1v16c0 1.1.9 2 2 2h16v-2H3V5zm11 7V8c0-1.11-.9-2-2-2h-1c-1.1 0-2 .89-2 2v1c0 1.11.9 2 2 2h1v1H9v2h3c1.1 0 2-.89 2-2zm-3-3V8h1v1h-1zm10-8H7c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V3c0-1.1-.9-2-2-2zm0 8h-2V7h-2v2h-2v2h2v2h2v-2h2v6H7V3h14v6z","key":1})]);
}

UnlimitedDepartments.displayName = "UnlimitedDepartments";

UnlimitedDepartments.defaultProps = {"fill":"#000000","height":"24","viewBox":"0 0 24 24","width":"24"};

module.exports = UnlimitedDepartments;

UnlimitedDepartments.default = UnlimitedDepartments;



//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/UnlimitedDepartments.svg
// module id = 654
// module chunks = 168707334958949